import core from '@gin-betting/core';

import { SkipInitialRequestConfig } from 'types';

const {
    utils: { getAppliedFilters, isOneOfPages },
} = core;

export default function checkSkipPollerConfiguration(
    config: SkipInitialRequestConfig | undefined
): boolean {
    if (!config) return false;

    const { pages, filterKey } = config;

    return isOneOfPages(pages) && !!getAppliedFilters()[filterKey];
}
